module.exports = __webpack_public_path__ + "img/ep-couronne.2e8668c2.jpg";